import {
  AbilityBuilder
} from '@casl/ability'

export default function defineAbilityFor(user) {
  const {
    rules,
    can,
    // cannot
  } = AbilityBuilder.extract()
  console.log(user)
  if (user == 'Admin' || user.includes('Admin')) {
    can('read', 'all')
    can('read', 'nav')
    can('read', 'workplaces')
  } else if (user == 'Customer' || user.includes('Customer')) {
    can('read', 'all')
    can('read', 'nav')
    can('read', 'workplaces')
  } else if (user == 'Workplace' || user.includes('Workplace')) {
    can('read', 'nav')
    can('read', 'workplaces')
  } else {
    can('read', 'workplaces')
  }

  return rules
}